import React from 'react';
import { AnimatedSkeletonLoader } from '@/components/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';
import { HubCardBaseSkeleton } from './hub-card-base-skeleton';
import { RestaurantInfoHeaderSkeleton } from './restaurant-info-header-skeleton';

export const HubLowestPerformingCustomersSkeleton = () => {
  const [styles] = useStyles();
  return (
    <HubCardBaseSkeleton
      actionsElement={
        <AnimatedSkeletonLoader
          height={36}
          style={styles.actionsElement}
          width="30%"
        />
      }
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <RestaurantInfoHeaderSkeleton key={index} />
      ))}
    </HubCardBaseSkeleton>
  );
};

const useStyles = createStyles(() => ({
  actionsElement: {
    marginTop: 0, // override since HubCardBaseSkeleton sets marginTop to 4 to provide gaps between different skeleton elements
  },
}));
